import { Flex, Tag, Text } from '@spotify-internal/encore-web';

import { KeyValueRow } from './KeyValueRow';
import { formatAllocation, formatCriteriaCount } from './formatters';

interface AudienceSummaryProps {
  targetingKeySelector?: string | null;
  allocationProportion?: unknown;
  criteriaCount: number;
}

export const AudienceSummary = ({
  targetingKeySelector,
  allocationProportion,
  criteriaCount,
}: AudienceSummaryProps) => {
  const allocationPercent = formatAllocation(allocationProportion);

  return (
    <Flex direction="column" gap="tighter-2">
      {targetingKeySelector && (
        <KeyValueRow label="Randomized by">
          <Tag>{targetingKeySelector}</Tag>
        </KeyValueRow>
      )}
      {allocationPercent && (
        <KeyValueRow label="Allocation">
          <Text variant="bodySmall">{allocationPercent}</Text>
        </KeyValueRow>
      )}
      <KeyValueRow label="Target">
        <Tag>
          {criteriaCount === 0
            ? 'All users'
            : formatCriteriaCount(criteriaCount)}
        </Tag>
      </KeyValueRow>
    </Flex>
  );
};
